import { ItemData } from 'core/models/Template'

export const WINE_CATALOG_TYPE = 'wine' as const

export const WINE_CATALOG_CONFIG = {
    type: WINE_CATALOG_TYPE,
    fixedHeader: true,
    isExistRightToolbar: false,
} as const

export type WineSelectedItems = ItemData[]
